import { Component, Input, Output, EventEmitter, HostListener, ViewChild, ContentChild } from '@angular/core';
import { toBoolean, uniqueId } from '../util/util';
import { NglModalFooter } from './footer';
import { NglModalHeaderTemplate } from './header';
var NglModal = (function () {
    function NglModal() {
        this.header = '';
        this.headingId = uniqueId('modal_header');
        this.openChange = new EventEmitter();
        this._open = true;
        this._directional = false;
    }
    Object.defineProperty(NglModal.prototype, "directional", {
        get: function () {
            return this._directional;
        },
        set: function (directional) {
            this._directional = toBoolean(directional);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NglModal.prototype, "open", {
        get: function () {
            return this._open;
        },
        set: function (_open) {
            var _this = this;
            _open = toBoolean(_open);
            if (_open === this.open)
                return;
            this._open = _open;
            if (this.open) {
                setTimeout(function () { return _this.focusFirst(); });
            }
        },
        enumerable: true,
        configurable: true
    });
    NglModal.prototype.close = function (evt) {
        if (evt) {
            evt.stopPropagation();
        }
        this.openChange.emit(false);
    };
    NglModal.prototype.focusFirst = function () {
        this.closeButton.nativeElement.focus();
    };
    NglModal.decorators = [
        { type: Component, args: [{
                    selector: 'ngl-modal',
                    template: "\n    <div class=\"slds-modal\" [class.slds-fade-in-open]=\"open\" [ngClass]=\"[size ? 'slds-modal--' + size : '']\" [attr.aria-hidden]=\"!open\" role=\"dialog\" [attr.aria-labelledby]=\"headingId\"><div class=\"slds-modal__container\"><div class=\"slds-modal__header\" [class.slds-modal__header--empty]=\"!header &amp;&amp; !headerTpl\"><button class=\"slds-button slds-button--icon-inverse slds-modal__close\" #closeButton type=\"button\" (click)=\"close()\"><svg class=\"slds-button__icon slds-button__icon--large\" nglIcon=\"close\"></svg><span class=\"slds-assistive-text\">Close</span></button><h2 class=\"slds-text-heading--medium\" *ngIf=\"header\" [id]=\"headingId\">{{header}}</h2><ng-template *ngIf=\"headerTpl\" [ngTemplateOutlet]=\"headerTpl.templateRef\" [ngTemplateOutletContext]=\"{id: headingId}\"></ng-template><ng-content select=\"[tagline]\"></ng-content></div><div class=\"slds-modal__content slds-p-around--medium\"><ng-content select=\"[body]\"></ng-content></div><div class=\"slds-modal__footer\" *ngIf=\"footer\" [class.slds-modal__footer--directional]=\"directional\"><ng-template [ngTemplateOutlet]=\"footer.templateRef\"></ng-template></div></div></div><div tabindex=\"0\" (focus)=\"focusFirst()\"></div><div class=\"slds-backdrop\" [class.slds-backdrop--open]=\"open\"></div>\n  ",
                    host: {
                        'tabindex': '0',
                    },
                },] },
    ];
    /** @nocollapse */
    NglModal.ctorParameters = function () { return []; };
    NglModal.propDecorators = {
        'header': [{ type: Input },],
        'size': [{ type: Input },],
        'directional': [{ type: Input },],
        'closeButton': [{ type: ViewChild, args: ['closeButton',] },],
        'open': [{ type: Input },],
        'openChange': [{ type: Output },],
        'headerTpl': [{ type: ContentChild, args: [NglModalHeaderTemplate,] },],
        'footer': [{ type: ContentChild, args: [NglModalFooter,] },],
        'close': [{ type: HostListener, args: ['keydown.esc', ['$event'],] },],
    };
    return NglModal;
}());
export { NglModal };
;
//# sourceMappingURL=modal.js.map